<script setup lang="ts">
defineOptions({
  name: "500"
});
</script>

<template>
  <ExceptionBase type="500" />
</template>

<style scoped></style>
